import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoriesSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 mb-16">
      <div className="text-center mb-10">
        <p className="text-sm font-medium text-accent-600 uppercase tracking-wider mb-2">八卦分类</p>
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950">
          按分类<span className="text-primary-500">吃瓜</span>
        </h2>
        <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
          六大门类覆盖娱乐圈全貌，精准定位你最关心的八卦类型
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              cat.color === 'accent' ? 'bg-accent-100 text-accent-600' :
              cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
              'bg-secondary-100 text-secondary-600'
            } group-hover:scale-110 transition-transform duration-300`}>
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}